import { apiClient } from "./apiClient";
import {
  setAcademicYearData,
  setAcademicYearListData,
  setEventPointsListDetails,
  setTermDataListDetails,
} from "../redux/TermDataReducer/TermDataSlice";
import { setSnackbarDetails } from "../redux/AuthReducer/AuthSlice";
import { dispatchEmployeeListData } from "../redux/EmployeeReducer/EmployeeSlice";
import {
  setActiveReward,
  setEmployeeRewardData,
  setEmployeeRewardPaginatedData,
  setTermCodeValue,
} from "../redux/RewardReducer/RewardsSlice";
import { setStudentListData } from "../redux/super_admin/studentsReducer/StudentsSlice";
import { setPlcEventDetails } from "../redux/plc/EventsReducer/EventsSlice";
import { setEventCategoryListRedux } from "../redux/DTS/EventCategoryReducer/EventCategorySlice";
import { SetStateAction } from "react";
import {
  setActivityList,
  setAgeRangeList,
  setParticipantCategoryList,
} from "../redux/tft/Master/MasterSlice";
import { setPlcTermCodesList } from "../redux/plc/ReportsReducer/ReportsSlice";
import { plcTermCodesList } from "../types/axios";

export interface employeePaginatedDetails {
  total: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

export interface paginatedDetails {
  total: number;
  pageNumber: number;
  rowsPerPage: number;
  totalPages: number;
}

export const fetchEventpointsList = async (dispatcher: any) => {
  try {
    let res = await apiClient.get<any>("/oc/term-data/event-points/list");
    dispatcher(setEventPointsListDetails(res?.data?.data));
    return res;
  } catch (error) {
    throw error;
  }
};

export const fetchTermCodeListGoalPoints = async () => {
  try {
    let res = await apiClient?.get<any>("/oc/term-data/goal-points/list");
    return res?.data?.data ?? [];
  } catch (error) {
    throw error;
  }
};

export const fetchOCEventsList = async (
  dispatcher: any,
  value: string,
  termCode: string,
) => {
  try {
    let res = await apiClient?.get<any>(
      `/oc/events/list?eventName=${value}&termCodeId=${termCode}`,
    );
    return res?.data?.data.events;
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.message ?? "Failed to Fetch The Events List!",
      }),
    );
    return null;
  }
};

export const fetchEmployeeList = async (
  paginationData: employeePaginatedDetails,
  searchValue: string,
  dispatcher: any,
) => {
  const params = new URLSearchParams({
    pageNumber: paginationData?.pageNumber?.toString() ?? "1",
    pageSize: paginationData?.pageSize?.toString() ?? "15",
  });

  if (searchValue.trim().length >= 2) {
    params.append("employeeName", searchValue.trim());
  }
  try {
    let res = await apiClient?.get<any>(`/employees/list?${params.toString()}`);
    dispatcher(dispatchEmployeeListData(res?.data?.data?.employees));
    return res?.data?.data;
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.message ??
          "Failed to Fetch The Employee List!",
      }),
    );
    return null;
  }
};

export const getEmployeesEligibleForRewards = async (
  tab: string,
  termCode: string,
  pageNumber: number,
  rowsPerPage: number,
  searchValue: string,
  dispatcher: any,
) => {
  const params = new URLSearchParams({
    pageNumber: pageNumber?.toString() ?? "1",
    pageSize: rowsPerPage?.toString() ?? "15",
    termCodeId: termCode,
  });

  if (searchValue.trim() !== "") {
    params.append("search", searchValue.trim());
  }
  let url =
    tab === "eligible"
      ? `/oc/rewards/term/eligible?${params.toString()}`
      : `/oc/rewards/term/not-eligible?${params.toString()}`;
  try {
    const res = await apiClient.get<any>(url);
    dispatcher(setEmployeeRewardData(res?.data?.data?.employees));
    dispatcher(
      setEmployeeRewardPaginatedData({
        pageNumber: res?.data?.data?.pagination?.pageNumber ?? 1,
        totalPages: res?.data?.data?.pagination?.totalPages ?? 1,
        rowsPerPage: res?.data?.data?.pagination?.pageSize ?? 15,
      }),
    );
    //return res?.data?.data ?? [];
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.message ??
          "Failed to Fetch The Eligible Employee List!",
      }),
    );
    return null;
  }
};

export const getListTermCodes = async (dispatcher: any) => {
  try {
    let res = await apiClient.get<any>("/oc/term-data/term-codes/list");
    let activeWard = res?.data?.data.find((item: any) => item.rewardToggleOn);
    // return res?.data?.data ?? [];
    dispatcher(setTermDataListDetails(res?.data?.data));
    // localStorage.setItem(
    //   "oc_all_in_termCodes",
    //   JSON.stringify(res?.data?.data),
    // );
    dispatcher(setTermCodeValue(res?.data?.data?.[0]?.id));
    dispatcher(setActiveReward(activeWard ?? null));
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.data ??
          error.response?.data?.message ??
          "Failed to fetch the term codes list!",
      }),
    );
    return null;
    // console.log(error);
  }
};

export const getRewardTypeList = async (dispatcher: any) => {
  try {
    let res = await apiClient?.get<any>(`/reward-type/list`);
    return res?.data?.data;
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.data?.message ??
          "Failed to Fetch The Rewards Type List",
      }),
    );
    return null;
  }
};

export const handleImport = async (
  file: File | null,
  dispatcher: any,
  setProgress: (progress: number) => void,
  setUploading: (status: boolean) => void,
  type: string = "employees",
) => {
  if (!file) return;
  try {
    const formData = new FormData();
    formData.append("file", file);
    let res = await apiClient?.post<any>(`/${type}/bulk-create`, formData, {
      onUploadProgress: (progressEvent: any) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total,
        );
        setProgress(percentCompleted);
      },
    });
    // const data = res?.data?.data?.data;

    // const duplicateEmails = data?.duplicateEmails || [];

    // const duplicateMessage =
    //   duplicateEmails.length > 0
    //     ? `\nDuplicate Emails:\n${duplicateEmails
    //         .map((item: any) => `• ${item.email} - ${item.reason}`)
    //         .join("\n")}`
    //     : "";
    // dispatcher(
    //   setSnackbarDetails({
    //     type: "success",
    //     message: `File Imported Successfully!, TotalProcessed: ${res?.data?.data?.data?.totalProcessed}, SuccessCount: ${res?.data?.data?.data?.successCount}, FailureCount:  ${res?.data?.data?.data?.failureCount}${duplicateMessage}`,
    //   }),
    // );
    dispatcher(
      setSnackbarDetails({
        type: "success",
        message: `File Imported Successfully!, Total ${type === "employees" ? "Employees" : "Students"} Inserted: ${res?.data?.data?.data?.successCount}`,
      }),
    );
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.data?.message ??
          "Error in Uploading the XLSX File!",
      }),
    );
  } finally {
    setUploading(false);
  }
};

export const fetchEmployeesFullList = async (
  dispatcher: any,
  searchValue: string,
) => {
  try {
    let url = searchValue
      ? `/employees/list?employeeName=${searchValue}&export=true`
      : `/employees/dropdown`;
    let res = await apiClient?.get<any>(url);
    return res?.data?.data;
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.data?.message ??
          "Failed to Fetch The Employee List!",
      }),
    );
    return null;
  }
};

export const fetchPlcEventList = async (tab: string, dispatcher: any) => {
  try {
    let res = await apiClient?.get<any>(
      `/plc/events?eventMode=${tab}&export=true`,
    );
    dispatcher(setPlcEventDetails(res?.data?.data?.events));
    return res?.data?.data;
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.data?.message ??
          "Failed To Fetch The Event List!",
      }),
    );
    return null;
  }
};

export const fetchDtsEventCategory = async (dispatcher: any) => {
  try {
    let res = await apiClient?.get<any>(
      `/dts/master/event-categories?isActive=true`,
    );
    dispatcher(setEventCategoryListRedux(res?.data?.data));
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.data?.message ??
          error?.response?.data?.data ??
          "Failed to fetch the event category list!",
      }),
    );
  }
};

export const fetchStudentsFullList = async (dispatcher: any) => {
  try {
    let res = await apiClient?.get<any>(`/students/list?&export=true`);
    const apiData = res?.data?.data;
    dispatcher(
      setStudentListData({
        students: apiData?.students ?? [],
        pagination: apiData?.pagination ?? {
          total: 0,
          pageNumber: 1,
          pageSize: 15,
          totalPages: 1,
        },
      }),
    );
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.data?.message ??
          "Failed to Fetch The Event Category List!",
      }),
    );
  }
};

export const fetchFileId = async (
  module: string,
  moduleUrl: string,
  file: any,
  dispatcher: any,
) => {
  let formData = new FormData();
  formData.append("file", file);
  formData.append("module", moduleUrl);
  try {
    let res = await apiClient?.post<any>(`${module}/files/upload`, formData);
    return res?.data?.data;
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.data?.message ??
          error?.response?.data?.data ??
          "Error in uploading the file!",
      }),
    );
  }
};

export const fetchParticipantCategoryList = async (dispatcher: any) => {
  try {
    let res = await apiClient?.get<any>(
      `/tft/participant-categories/list?isActive=true`,
    );
    dispatcher(setParticipantCategoryList(res?.data?.data ?? []));
    return res?.data?.data ?? [];
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.data?.message ??
          error?.response?.data?.data ??
          "Error in uploading the file!",
      }),
    );
    console.log(error);
    return [];
  }
};

export const fetchAgeRangeList = async (dispatcher: any) => {
  try {
    let res = await apiClient?.get<any>(`/tft/age-range/list?isActive=true`);
    dispatcher(setAgeRangeList(res?.data?.data ?? []));
    return res?.data?.data ?? [];
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.data?.message ??
          error?.response?.data?.data ??
          "Failed to fetch the age range list!",
      }),
    );
    return [];
  }
};

export const fetchActivityList = async (dispatcher: any) => {
  try {
    let res = await apiClient?.get<any>(`/tft/activities/list`);
    dispatcher(setActivityList(res?.data?.data ?? []));
    return res?.data?.data ?? [];
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.data?.message ??
          error?.response?.data?.data ??
          "Failed to fetch the activity list!",
      }),
    );
    return [];
  }
};

export const fetchTftParticipantsListDropdown = async (dispatcher: any) => {
  try {
    let res = await apiClient?.get<any>(`/tft/participants/list/dropdown`);
    return res?.data?.data ?? [];
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.data?.message ??
          error?.response?.data?.data ??
          "Failed to fetch the participants list!",
      }),
    );
    return [];
  }
};

export const fetchTftChallengesListDropdown = async (dispatcher: any) => {
  try {
    let res = await apiClient?.get<any>(`/tft/challenges/list/dropdown`);
    return res?.data?.data ?? [];
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.data?.message ??
          error?.response?.data?.data ??
          "Failed to fetch the challenges list!",
      }),
    );
    return [];
  }
};

export const handleTftWinnersDetailApi = async (
  details: any,
  exportStatus: boolean,
  categortType: string,
  categoryError: string,
  dispatcher: any,
  paginationData?: paginatedDetails,
) => {
  if (!details?.challengeId) return null;
  try {
    const params = new URLSearchParams({
      pageNumber: paginationData?.pageNumber?.toString() ?? "1",
      pageSize: paginationData?.rowsPerPage?.toString() ?? "15",
    });
    let url = exportStatus
      ? `/tft/winners/challenges/grand-prizes/${details?.challengeId}/details?type=${categortType}&${params.toString()}`
      : `/tft/winners/challenges/grand-prizes/${details?.challengeId}/details?type=${categortType}$export=true`;
    let res = await apiClient?.get<any>(url);
    return res?.data?.data;
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.data?.message ??
          `Error In Fetching The ${categoryError} Details!`,
      }),
    );
  }
};

export const handleActiveAcademicYear = async (dispatcher: any) => {
  try {
    let res = await apiClient?.get<any>(`/academic-year/list?isActive=true`);
    localStorage.setItem("academic_year", JSON.stringify(res?.data?.data));
    dispatcher(setAcademicYearListData(res?.data?.data));
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.data?.message ??
          "Error In Fetching The Academic Year",
      }),
    );
  }
};

export const handlePlcAcademicYear = async (dispatcher: any) => {
  try {
    let res = await apiClient?.get<any>(
      `/plc-academic-year/list?isActive=true`,
    );
    localStorage.setItem("academic_year", JSON.stringify(res?.data?.data));
    dispatcher(setAcademicYearListData(res?.data?.data));
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.data?.message ??
          "Error In Fetching The Academic Year",
      }),
    );
  }
};

// export const handlePlcTermCodesList = async (dispatcher: any) => {
//   try {
//     let res = await apiClient?.get<any>(`/plc/term-codes/list`);
//     const allTerm: plcTermCodesList = {
//       id: "1",
//       academicYearId: "",
//       termCode: "All",
//       displayName: "",
//       startDate: "",
//       endDate: "",
//       rewardToggleOn: false,
//       isActive: true,
//       createdAt: "",
//       updatedAt: "",
//       currentTerm: false,
//     };
//     dispatcher(setPlcTermCodesList([allTerm, ...res?.data?.data]));
//   } catch (error: any) {
//     dispatcher(
//       setSnackbarDetails({
//         type: "error",
//         message:
//           error?.response?.data?.data ??
//           error?.response?.data?.data?.message ??
//           "Failed to fetch term codes list",
//       }),
//     );
//   }
// };
